import * as React from "react";

type ContributionProps = {
    value: number;
    interval: string;
};

class Contribution extends React.Component<ContributionProps> {

    getInterval(): string {
        const intervals = {
            "month": "mois",
            "trimester": "trimestre",
            "semester": "semestre",
            "year": "année"
        };
        return intervals[this.props.interval];
    }

    public render() {
        return (
           <span>
              <span style={{fontSize: "1.2rem", fontWeight: "bold"}}>
                {Number(this.props.value).toFixed(2)} €
              </span>   
              {this.getInterval() ?
                <span>    
                    /{this.getInterval()}
                </span>
              : null}
           </span>
        );
    }
}

export default Contribution;



// WEBPACK FOOTER //
// ./src/components/Contribution/Contribution.tsx